var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(1.75) translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.90039C5.33137 4.90039 5.59961 5.16863 5.59961 5.5V7.5C5.59961 7.72091 5.77909 7.90039 6 7.90039H9.55273L8.57617 6.92383C8.34186 6.68951 8.34186 6.31049 8.57617 6.07617C8.81049 5.84186 9.18951 5.84186 9.42383 6.07617L11.4238 8.07617C11.5364 8.18869 11.5996 8.34087 11.5996 8.5C11.5996 8.65913 11.5364 8.81131 11.4238 8.92383L9.42383 10.9238C9.18951 11.1581 8.81049 11.1581 8.57617 10.9238C8.34186 10.6895 8.34186 10.3105 8.57617 10.0762L9.55273 9.09961H6C5.11634 9.09961 4.40039 8.38366 4.40039 7.5V5.5C4.40039 5.16863 4.66863 4.90039 5 4.90039Z",
    fill: "#002A69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDeclined);
export default __webpack_public_path__ + "static/media/Arrow_declined.27be18b8cd394ad3c990964a2ee8c9c3.svg";
export { ForwardRef as ReactComponent };